import { $safeApply } from '@buildium/angularjs-core/dist/utilities/angularjs';
import Cookies from 'js-cookie';
import { hashErrorString } from '../../../../manager-base/app-base/config/error-override';

export function LoginController(
    $q,
    $scope,
    $window,
    $stateParams,
    ApiError,
    AuthenticationError,
    BdLocalize,
    LoginService,
    PublicAuthenticationApi,
    PublicForgotPasswordApi,
    Notify,
    SeasonalBackgroundImageSource,
    RecaptchaService,
    ReCaptchaProtectedAction,
    loginSettings,
    Page,
    SuperUser,
    SessionStorageCacheService,
    ALERT_TYPE,
    STATIC_IMAGES_PUBLIC_PATH,
    PublicPageLogApi,
    BASE_PATH_APP,
    BASE_PATH_PUBLIC,
    isAuthServerEnabled,
    IS_LOCALHOST,
    HYBRID_LOCALHOST,
    PUBLIC_HYBRID_LOCALHOST
) {
    const vm = this;
    const rememberUserEmailCookieName = 'rememberEmailCookie';
    vm.isAuthServerEnabled = isAuthServerEnabled;
    vm.emailAddress = null;
    vm.password = null;
    vm.rememberMyEmail = false;
    vm.isGlobalModeLogin = loginSettings.IsGlobalModeLogin;
    vm.isTrialAccount = loginSettings.IsTrialAccount;
    vm.LoginToken = loginSettings.LoginToken;
    vm.showBuildiumLogo = vm.isGlobalModeLogin || vm.isTrialAccount;
    vm.isSubscriberPickerVisible = false;
    vm.matchedSubscribers = [];
    vm.showIncorrectEmailOrPassword = false;
    vm.showSomethingWentWrongMessage = false;
    vm.showRequiredEmailAddress = false;
    vm.showRequiredPassword = false;
    vm.isShowingChangePasswordModal = false;
    vm.forgotPasswordEmailInput = '';
    vm.isForgotPasswordSubscriberPickerVisible = false;
    vm.matchedForgotPasswordSubscribers = [];
    vm.seasonalBackgroundImageSource = `${STATIC_IMAGES_PUBLIC_PATH}/${SeasonalBackgroundImageSource}`;
    vm.bldmLoginImageSource = `${STATIC_IMAGES_PUBLIC_PATH}/buildium_logo.png`;
    vm.reCaptchaSettings = loginSettings.RecaptchaSettings;
    vm.hasAuthError = false;
    vm.showDemoAccountPasswordResetWarning = false;
    vm.showExisingTrialWarning = false;
    vm.authErrorMessage = '';
    vm.showTooManyInvalidLoginAttempts = false;
    vm.ALERT_TYPE = ALERT_TYPE;

    vm.checkYourEmailInboxMsg = BdLocalize.getString('Public.Login.DemoAccountResetPasswordWarning', 'Check your email inbox for instructions on how to reset your password.');

    vm.existingTrialWarningMsg = BdLocalize.getString('Public.Login.ExistingTrialWarning.FullMsg', 'Hang on, you already have an active trial with us. Please sign in below. If you have any questions, call our team at 877-396-7876. We\'re here to help!');
    vm.somethingWentWrongMsg = BdLocalize.getString('Public.Login.BadRequest.SomethingWentWrong', 'Something went wrong. Please refresh your page and try again.');
    vm.tooManyAttemptsHeader = BdLocalize.getString('Public.Login.Login.TooManyUnsuccessfulSignInAttempts', 'Sorry, ', null, 'bold');
    vm.tooManyAttemptsMsg = BdLocalize.getString('Public.Login.Login.TooManyUnsuccessfulSignInAttempts', 'you have made too many unsuccessful sign-in attempts. Please try again later.', null, 'p2');
    vm.incorrectEmailOrPasswordHeader = BdLocalize.getString('Public.Login.Login.EmailOrPasswordIncorrect', 'Sorry, ', null, 'bold');
    vm.incorrectEmailOrPasswordMsg = BdLocalize.getString('Public.Login.Login.EmailOrPasswordIncorrect', 'you entered an incorrect email address or password.', null, 'p2');
    vm.validEmailAddressMsg = BdLocalize.getString('Public.Login.Login.PleaseEnterAnEmailAddress', 'Please enter a valid email address.');
    vm.enterPasswordMsg = BdLocalize.getString('Public.Login.Login.PleaseEnterPassword', 'Please enter a password.');

    vm.residentCenterLoginLink = vm.isGlobalModeLogin
        ? `${$window.location.protocol}//${$window.location.hostname}/Resident/portal/global-login`
        : `${$window.location.protocol}//${$window.location.hostname}/Resident/portal/login`;

    vm.isPublicHybridLocalhost = $window.location.host === PUBLIC_HYBRID_LOCALHOST;

    function resetSignInButtonText() {
        vm.signInButtonText = BdLocalize.getString('Public.Login.Login.SignInButton', 'Sign in');
    }

    function createRememberEmailCookie(emailAddress) {
        const cookieAttributes = {
            path: '/', expires: 365, secure: true
        };

        cookieAttributes.sameSite = 'strict';

        Cookies.set(rememberUserEmailCookieName, emailAddress, cookieAttributes);
    }

    function checkRememberedEmail() {
        if (Cookies.get(rememberUserEmailCookieName) !== undefined) {
            vm.emailAddress = Cookies.get(rememberUserEmailCookieName);
            vm.rememberMyEmail = true;
        }
    }

    function checkAuthError() {
        if (typeof $stateParams.authError !== 'undefined') {
            switch (parseInt($stateParams.authError.substring(0, 1), 10)) {
                case AuthenticationError.InvalidThirdPartyAddressError:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.InvalidThirdPartyAddressError', 'Sorry, you could not be logged in via the third-party provider. Please choose a different email address or contact your system administrator.');
                    break;
                case AuthenticationError.InvalidNoEmailLogin:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.InvalidNoEmailLogin', `Sorry, the email address associated with your ${$stateParams.authError.substring(1)} account doesn't match your Buildium account. Change your ${$stateParams.authError.substring(1)} or Buildium profile so the emails match, or use a different sign in method.`, [$stateParams.authError.substring(1), $stateParams.authError.substring(1)]);
                    break;
                case AuthenticationError.InvalidMultipleEmailLogin:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.InvalidMultipleEmailLogin', `Sorry, the email address associated with your  ${$stateParams.authError.substring(1)} account matches multiple Buildium accounts. Please sign in using the email address and password fields.`, [$stateParams.authError.substring(1)]);
                    break;
                case AuthenticationError.InvalidTokenErrorMessage:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.InvalidTokenErrorMessage', 'Sorry, this link has expired. If you are trying to reset your password, please use the reset password link below.');
                    break;
                case AuthenticationError.ThirdPartyProviderNotSupported:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.ThirdPartyProviderNotSupported', `Sorry, you cannot sign in with ${$stateParams.authError.substring(1)} at this time. Please choose a different sign-in method and try again.`, [$stateParams.authError.substring(1)]);
                    break;
                case AuthenticationError.BlockedUserError:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.Login.BlockedUserMessage', 'It looks like you\'re unable to access your account. Please contact your property manager.');
                    break;
                case AuthenticationError.UserHasToConfigure2Fa:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.UserHasToConfigure2FaMessage', 'Please log in to configure two factor authentication.');
                    break;
                default:
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.UnknownError', 'Something went wrong. Please refresh your page and try again.');
                    break;
            }
            vm.hasAuthError = true;
        } else {
            vm.hasAuthError = false;
            vm.authErrorMessage = '';
        }
    }

    function handlePasswordResetWarning() {
        // We only show the warning if the warnPassReset parameter is present in the query string with
        // the value as "1" and we are not in the global mode login.
        if ($stateParams.warnPassReset === '1' && !vm.isGlobalModeLogin) {
            vm.showDemoAccountPasswordResetWarning = true;
        }
    }

    function handleExistingTrialWarning() {
        // We only show the warning if the warnPassReset parameter is present in the query string with
        // the value as "1".
        if ($stateParams.existingTrial === '1') {
            vm.showExisingTrialWarning = true;
        }
    }

    function getSslParameterIfExists() {
        if ($stateParams) {
            const ssoParam = $stateParams.sso; 
            if (ssoParam) {
                return ssoParam;
            }
            const returnUrl = $stateParams.returnUrl || $stateParams.ReturnUrl;
            if (returnUrl) {
                const queryParams = new URLSearchParams(returnUrl.split('?')[1]);
                return queryParams.get('sso');
            }
        }
        return null;
    }

    function initialize() {
        if (isAuthServerEnabled) {
            // if IS_LOCALHOST then assign managerRedirectUrl as isolated local development
            // else is monolithic IIS served then assume our mount path is {host}/manager/app
            let managerRedirectUrl = IS_LOCALHOST ? `https://${HYBRID_LOCALHOST}` : `${$window.location.origin}${BASE_PATH_APP}`;
            const ssoParam = getSslParameterIfExists();
            if (ssoParam) {
                managerRedirectUrl = `${managerRedirectUrl}/sso-callback?provider=${ssoParam}`;
            } 
            $window.location.assign(managerRedirectUrl);
        } else {
            Page.addBodyClass('public-authentication-login');
            vm.subscriberPickerModalTitleText = BdLocalize.getString('Public.Login.SubscriberPicker.ModalTitle', 'Select an account');
            vm.subscriberPickerBodyText = BdLocalize.getString('Public.Login.SubscriberPicker.BodyText', 'Your email address is associated with multiple Buildium accounts. Please select an account to sign in.');
            vm.subscriberForgotPasswordPickerTitleText = BdLocalize.getString('Public.Login.ForgotPassword.SubscriberPicker.BodyTitle', 'Reset your password');
            vm.subscriberForgotPasswordPickerBodyText = BdLocalize.getString('Public.Login.ForgotPassword.SubscriberPicker.BodyText', 'Your email address is associated with multiple Buildium accounts. Please select an account to reset your password.');
            resetSignInButtonText();
            checkRememberedEmail();
            checkAuthError();
            handlePasswordResetWarning();
            handleExistingTrialWarning();

            SessionStorageCacheService.clear();

            // handle sso parameter
            const ssoParam = getSslParameterIfExists();
            if (ssoParam) {
                sessionStorage.setItem('ssoParam', ssoParam);
            }
        }
    }

    function showSubscriberPicker(subscribers) {
        vm.matchedSubscribers = subscribers;
        vm.isSubscriberPickerVisible = true;
    }

    function getDomainSpecificRedirectUrl(redirectUrl, accountDomain) {
        const domainSpecificHost = accountDomain;
        const baseUrl = `https://${domainSpecificHost}`;
        const domainSpecificRedirectUrl = new URL(redirectUrl, baseUrl).href;

        return domainSpecificRedirectUrl;
    }

    function showForgotPasswordSubscriberPicker(subscribers) {
        vm.matchedForgotPasswordSubscribers = subscribers;
        vm.isForgotPasswordSubscriberPickerVisible = true;
    }

    function handleSsoRedirect(accountDomain) {
        const ssoParam = sessionStorage.getItem('ssoParam');
        if (ssoParam) {
            sessionStorage.removeItem('ssoParam');
            return getDomainSpecificRedirectUrl(`sso-callback?provider=${ssoParam}`, accountDomain);
        }
        return null;
    }

    function handlePreAuthenticatedSsoRedirect(redirectUrl) {
        const ssoParam = sessionStorage.getItem('ssoParam');
        if (ssoParam) {
            const url = new URL(redirectUrl);
            const params = new URLSearchParams(url.search);
    
            // Update the returnUrl parameter
            params.set('returnUrl', `${BASE_PATH_APP}/sso-callback?provider=${ssoParam}`);
    
            // Construct the new URL
            url.search = params.toString();
            return url.toString();
        }
        return null;
    }

    function signInSubscriberWithCredentials(accountId, accountDomain, reCaptchaToken, userId, userGuid) {
        const userName = userGuid === undefined || userGuid === null ? vm.emailAddress : userGuid;

        return LoginService.loginSubscriberWithToken(
            vm.LoginToken,
            userName,
            vm.password,
            $stateParams.returnUrl || $stateParams.ReturnUrl,
            accountId,
            reCaptchaToken,
            userId)
            .then(response => {
                let redirectUrl = response.RedirectUrl;

                // Add environment-specific base path
                // Since LoginService returns a redirectUrl with '/manager/app' or '/manager/public',
                // we'll trim and replace with an environment-aware constant
                const isPublicAppRedirect = redirectUrl.substring(0, 12).toLowerCase() === '/manager/pub';
                const isAuthenticatedAppRedirect = redirectUrl.substring(0, 12).toLowerCase() === '/manager/app';

                if (isPublicAppRedirect) {
                    redirectUrl = `${BASE_PATH_PUBLIC}${redirectUrl.slice(15)}`;
                } else if (isAuthenticatedAppRedirect) {
                    redirectUrl = `${BASE_PATH_APP}${redirectUrl.slice(12)}`;
                } else {
                    // don't modify 'redirectUrl', no need for an environment-specific base path
                }

                if (accountId) {
                    let redirectDomain = accountDomain;
                    
                    if (isPublicAppRedirect && (accountDomain === HYBRID_LOCALHOST)) {
                        redirectDomain = PUBLIC_HYBRID_LOCALHOST;
                    }

                    // A request has been made using an accountId, which means the subscriber we are signing in
                    // is the result of a lookup in the context of a global mode sign in.
                    // We must redirect to the account specific domain.
                    redirectUrl = getDomainSpecificRedirectUrl(redirectUrl, redirectDomain);
                }

                // Sets the user email cookie if the checkbox is checked
                if (vm.rememberMyEmail) {
                    createRememberEmailCookie(vm.emailAddress);
                } else {
                    Cookies.remove(rememberUserEmailCookieName, { path: '/' });
                }

                // Clear resource string data when signing in through the domains signin portal
                window.localStorage.removeItem('rss-data');
                window.localStorage.removeItem('rss-last-requested');
                window.localStorage.removeItem('last-resource-string-request');

                // Clear unread messages when signing in
                window.localStorage.removeItem(`${userId}_unread-messages-count`);
                window.localStorage.removeItem(`${userId}_unread-messages-last-requested`);

                // Clear shortuts when signing in
                window.localStorage.removeItem(`${userId}_shortcuts`);

                //handle sso param
                if (isAuthenticatedAppRedirect) {
                    redirectUrl = handleSsoRedirect(accountDomain) ?? redirectUrl;
                } else {
                    redirectUrl = handlePreAuthenticatedSsoRedirect(redirectUrl) ?? redirectUrl;
                }
                
                $window.location.assign(redirectUrl);
                // We return a deferred promise so that the login button remains not clickable up
                // until the point when the redirect occurs.
                return $q.defer().promise;
            })
            .catch(error => {
                if (error.status === 400) {
                    // BadRequest.
                    // This can happen if the reCAPTCHA token validation fails but also other cases.
                    // In this case we show a generic message to the user instructing that the page should
                    // be refreshed and the user should try to login again.
                    vm.showSomethingWentWrongMessage = true;
                } else if (error.status === 401) {
                    // Unauthorized.
                    if (error.data.ErrorCode === '225') {
                        vm.authErrorMessage = BdLocalize.getString('Public.Login.Login.BlockedUserMessage', 'It looks like you\'re unable to access your account. Please contact your property manager.');
                        vm.hasAuthError = true;
                        vm.isSubscriberPickerVisible = false;
                    } else if (error.data.ErrorCode === '231') {
                        vm.authErrorMessage = BdLocalize.getString('Public.Login.Login.PartnerPortalNoAccess', 'You do not have access to the partner portal.');
                        vm.hasAuthError = true;
                        vm.isSubscriberPickerVisible = false;
                    } else {
                        vm.showIncorrectEmailOrPassword = true;
                    }
                } else if (error.status === 403) {
                    // Token was missing (403 Forbidden)
                    // Token is invalid (signature, IP address) (403 Forbidden)
                    // Token is expired (403 Forbidden)
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.UnknownError', 'Something went wrong. Please refresh your page and try again.');
                    vm.hasAuthError = true;
                    vm.isSubscriberPickerVisible = false;
                } else if (error.status === 429) {
                    // Too many requests.
                    // We are rejecting the login if there are too  many invalid login attempts.
                    vm.showTooManyInvalidLoginAttempts = true;
                }

                $safeApply($scope);
            });
    }

    function evalReCaptchaAndSignInSubscriberWithCredentials(accountId, accountDomain, userId, userGuid) {
        // We evaluate if reCAPTCHA is in use and if so, we have to get the token for validation
        // before making the login request.
        if (vm.reCaptchaSettings.IsEnabled) {
            return RecaptchaService.getToken(vm.reCaptchaSettings.SiteKey, ReCaptchaProtectedAction.Login)
                .then(reCaptchaToken => {
                    return signInSubscriberWithCredentials(accountId, accountDomain, reCaptchaToken, userId, userGuid);
                }).catch((error) => {
                    const hashedErrorCode = hashErrorString(error.stack);
                    const logDto = {
                        Message: error.message,
                        Location: $window.location.pathname,
                        Hash: hashedErrorCode,
                        CallStack: error.stack,
                        UserAgent: $window.navigator.userAgent
                    };
                    PublicPageLogApi.logError(logDto);
                });
        } else {
            return signInSubscriberWithCredentials(accountId, accountDomain, null, userId, userGuid);
        }
    }

    function signInSubscriber(subscriber) {
        if (vm.isPublicHybridLocalhost) {
            subscriber.Url = HYBRID_LOCALHOST;
        }

        return evalReCaptchaAndSignInSubscriberWithCredentials(subscriber.AccountId, subscriber.Url, subscriber.UserId, subscriber.UserGuid);
    }

    function lookupSubscribers() {
        return LoginService.lookupSubscribersWithToken(vm.LoginToken, vm.emailAddress, vm.password)
            .then(subscribers => {
                if (subscribers.length > 1) {
                    // We have more than one subscriber matching the provided credentials.
                    // We must show the subscriber picker.
                    showSubscriberPicker(subscribers);

                    return $q.when(true);
                } else if (subscribers.length === 1) {
                    // Only one subscriber matches the credentials.
                    // We can immediately sign in the subscriber that matched.
                    return signInSubscriber(subscribers[0]);
                }

                return $q.when(false);
            })
            .catch(error => {
                if (error.status === 401) {
                    // Unauthorized
                    if (error.data.ErrorCode === '225') {
                        vm.authErrorMessage = BdLocalize.getString('Public.Login.Login.BlockedUserMessage', 'It looks like you\'re unable to access your account. Please contact your property manager.');
                        vm.hasAuthError = true;
                        vm.isSubscriberPickerVisible = false;
                    } else {
                        vm.showIncorrectEmailOrPassword = true;
                    }
                } else if (error.status === 429) {
                    // Too many requests.
                    // We are rejecting the login if there are too  many invalid login attempts.
                    vm.showTooManyInvalidLoginAttempts = true;
                } else if (error.status === 403) {
                    // Token was missing (403 Forbidden)
                    // Token is invalid (signature, IP address) (403 Forbidden)
                    // Token is expired (403 Forbidden)
                    vm.authErrorMessage = BdLocalize.getString('Public.Login.AuthenticationError.UnknownError', 'Something went wrong. Please refresh your page and try again.');
                    vm.hasAuthError = true;
                    vm.isSubscriberPickerVisible = false;
                }

                return $q.when(false);
            });
    }

    function submitForgotPassword(subscriber) {
        const request = {
            Email: vm.forgotPasswordEmailInput,
            AccountId: typeof subscriber === 'undefined' ? 0 : subscriber.AccountId
        };

        return PublicForgotPasswordApi.forgotPassword(request)
            .then(() => {
                Notify.success(
                    BdLocalize.getString('Public.Login.ForgotPassword.CheckEmail', `Check your ${vm.forgotPasswordEmailInput} email account for instructions to reset your password`, [vm.forgotPasswordEmailInput])
                );
                vm.closeModal();
                return $q.when(true);
            })
            .catch(error => {
                if (error.status === 422 && error.data.ErrorCode === '212') {
                    PublicForgotPasswordApi.getAccounts({ email: request.Email })
                        .then(data => {
                            if (data !== undefined) {
                                if (data.length > 1) {
                                    vm.closeModal();
                                    showForgotPasswordSubscriberPicker(data);
                                    return $q.when(true);
                                }
                            }
                            const errorMessage = BdLocalize.getString('Public.Login.ForgotPassword.SubscriberPicker.NoSubscribers', 'Sorry, we couldn\'t find any users associated with that email address.');
                            Notify.error(errorMessage);
                            return $q.reject(errorMessage);
                        })
                        .catch(() => {
                            Notify.success(
                                BdLocalize.getString('Public.Login.ForgotPassword.CheckEmail', `Check your ${vm.forgotPasswordEmailInput} email account for instructions to reset your password`, [vm.forgotPasswordEmailInput])
                            );
                            vm.closeModal();
                            return $q.when(true);
                        });
                }
            });
    }

    function isSuperAdminUser() {
        return vm.emailAddress.startsWith(SuperUser.SuperUserPrefix);
    }

    vm.signIn = function signIn() {
        vm.showIncorrectEmailOrPassword = false;
        vm.showSomethingWentWrongMessage = false;
        vm.showBlockedUserMessage = false;
        vm.showTooManyInvalidLoginAttempts = false;

        if (!vm.emailAddress || !vm.password) {
            vm.showRequiredEmailAddress = !vm.emailAddress;
            vm.showRequiredPassword = !vm.password;

            return $q.when(false);
        } else {
            vm.showRequiredEmailAddress = false;
            vm.showRequiredPassword = false;
        }

        if (isSuperAdminUser()) {
            return evalReCaptchaAndSignInSubscriberWithCredentials();
        } else {
            return lookupSubscribers();
        }
    };

    vm.loginSelectedSubscriber = function loginSelectedSubscriber(subscriber) {
        signInSubscriber(subscriber);
    };

    vm.forgotPasswordSelectedSubscriber = function forgotPasswordSelectedSubscriber(subscriber) {
        vm.isForgotPasswordSubscriberPickerVisible = false;
        return submitForgotPassword(subscriber);
    };

    vm.onCloseSubscriberPicker = function onCloseSubscriberPicker() {
        resetSignInButtonText();
    };

    vm.onForgotPasswordCloseSubscriberPicker = function onForgotPasswordCloseSubscriberPicker() {
        vm.forgotPasswordEmailInput = '';
    };

    vm.forgotPasswordClick = function forgotPasswordClick() {
        vm.forgotPasswordEmailInput = vm.emailAddress;
        vm.isShowingChangePasswordModal = true;
    };

    vm.closeModal = function closeModal() {
        vm.isShowingChangePasswordModal = false;
    };

    vm.requestPasswordReset = function requestPasswordReset() {
        return submitForgotPassword();
    };

    vm.signInThroughGoogle = function signInThroughGoogle() {
        let returnUrl = ($stateParams.returnUrl || $stateParams.ReturnUrl) || `${BASE_PATH_APP}/homepage/dashboard`;
        const ssoParam = sessionStorage.getItem('ssoParam');
        if (ssoParam) {
            sessionStorage.removeItem('ssoParam');
            returnUrl = `sso-callback?provider=${ssoParam}`;
        }
        return PublicAuthenticationApi.loginThroughGoogle({ returnUrl })
            .then(response => {
                $window.location.assign(response);
            })
            .catch(error => {
                ApiError.notify(error);
                return $q.reject(error);
            });
    };

    initialize();
}

LoginController.$inject = [
    '$q',
    '$scope',
    '$window',
    '$stateParams',
    'ApiError',
    'AuthenticationError',
    'BdLocalize',
    'LoginService',
    'PublicAuthenticationApi',
    'PublicForgotPasswordApi',
    'Notify',
    'SeasonalBackgroundImageSource',
    'RecaptchaService',
    'ReCaptchaProtectedAction',
    'loginSettings',
    'Page',
    'SuperUser',
    'SessionStorageCacheService',
    'ALERT_TYPE',
    'STATIC_IMAGES_PUBLIC_PATH',
    'PublicPageLogApi',
    'BASE_PATH_APP',
    'BASE_PATH_PUBLIC',
    'isAuthServerEnabled',
    'IS_LOCALHOST',
    'HYBRID_LOCALHOST',
    'PUBLIC_HYBRID_LOCALHOST'
];
